import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Generic.b3632204",
  "use": "Generic.b3632204-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"Generic.b3632204\">\n  <path d=\"M21.738 18.347l-8.26-8.31c.817-2.1.363-4.567-1.362-6.302C10.301 1.91 7.577 1.544 5.4 2.548l3.903 3.927-2.723 2.74-3.994-3.927c-1.09 2.192-.635 4.931 1.18 6.758 1.725 1.735 4.176 2.192 6.263 1.37l8.26 8.31a.874.874 0 001.271 0l2.088-2.1c.454-.366.454-1.005.091-1.279z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol